'use strict';

var autenticacaoMdl = angular.module('autenticacaoMdl');

autenticacaoMdl.service('Usuario', usuarioSrv);

usuarioSrv.$inject = [
    '$http',
    '$cookies',
    'ConfigApp',
    '$timeout',
    '$state',
    '$sessionStorage',
    '$q',
    'NotificacaoStream'
];

function usuarioSrv(
    $http,
    $cookies,
    ConfigApp,
    $timeout,
    $state,
    $sessionStorage,
    $q,
    NotificacaoStream) {

    this.autorizado = false;
    this.estadoMemorizado = null;
    this.autenticado = null;

    this.resetarAutorizacao = function () {
        this.autorizado = false;
        this.estadoMemorizado = null;
    }

    this.irPara = function (retirada) {
        this.autorizado = true;
        var estado = this.estadoMemorizado ? this.estadoMemorizado : retirada;
        $state.go(estado);
    }

    this.login = function (usuario) {
        var self = this;
        usuario.grant_type = 'password';
        
        var req = {
            method: 'POST',
            url: ConfigApp.UrlApi + '/token?sistemaId=' + ConfigApp.CentralAppId,
            headers: {
                'Authorization': undefined,
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: $.param(usuario)
        };

        return $http(req).then(function (response) {
            $timeout(function () {
                toastr.warning('Seu token expirou, por favor autentique novamente.', 'Autenticação');
                self.logout();
            }, (response.data.expires_in * 3600));

            $cookies.put('api_token', response.data.access_token);
        }, function (error) {
            return $q.reject(error);
        });
    }

    this.logout = function () {       
        this.resetarAutorizacao();

        $sessionStorage.$reset();
        $cookies.remove('api_token');
        window.location = ConfigApp.UrlLogin;
    }

    this.credencial = function () {
        var self = this, deferred = $q.defer();
        var credencial = $sessionStorage.credencial || this.autenticado;

        if(credencial){
            deferred.resolve(credencial);          
        }

        $http.get(ConfigApp.UrlApi + '/v1.0/seguranca/sistemas/' + ConfigApp.CentralAppId + '/credencial', {}, { ignoreLoadingBar: true }).then(function (credencial) {
            $sessionStorage.credencial = credencial;

            this.autenticado = credencial;

            NotificacaoStream.conectar().then(function() {
                    
                    angular.module('app').value('hubConnection', credencial.data.canaisDeAtendimento )

                    NotificacaoStream
                    .canais( credencial.data.canaisDeAtendimento )
                    .usuario( credencial.data.usuario );
            })
            

            deferred.resolve(credencial);
        }.bind(this));

        return deferred.promise;
    }

    this.verificarAutorizacao = function(){

        var credencial = $sessionStorage.credencial || true;

        if(credencial){
            this.autorizado = true;
        }

        return this.autorizado;
    }

    this.recuperarSenha = function () {
        var self = this, deferred = $q.defer();
    
        $http.get(ConfigApp.UrlApi + '/v1.0/recuperar_senha', {}, { ignoreLoadingBar: true }).then(function (response) {            
            deferred.resolve(response);
        }.bind(this));
        return deferred.promise;
    }
    
    this.recuperarSenhaContabilizar = function (recuperacaoSenhaId) {        
        var self = this, deferred = $q.defer();
        $http.post(ConfigApp.UrlApi + '/v1.0/recuperar_senha/' + recuperacaoSenhaId, {}, { ignoreLoadingBar: true }).then(function (response) {
            deferred.resolve(response);
        }.bind(this));
        return deferred.promise;
    }

}


// WEBPACK FOOTER //
// ./src/modules/autenticacao/usuario-service.js